import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useToast } from "../../hooks/useToast";
import { validateEmail } from "../../../helpers/utilities";
import { verifyEmail } from "../../Reducers/actions/authActions";
import Separator from "../../components/Separator/Separator";
import Input from "../../components/Input/Input";
import "./Auth.scss";
import { supabase } from "../../../supabase";

export default function SendInvite() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null)
    const navigate = useNavigate();
    // const toast = useToast();

    useEffect(() => {
        const checkUser = async () => {
            const { data } = await supabase.auth.getSession();
            if (data.session && data.session) {
                navigate("/");
            }
        };
        checkUser();

    }, [navigate]);

    const handleSignUp = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (validateEmail(email)) {
            verifyEmail(email).then(({ success, message }) => {
                if (success) {
                    localStorage.setItem("email", email)
                    setLoading(false)
                    navigate("/signup")
                } else {
                    setLoading(false);
                    setErrorMessage(message)
                }
            })
        }

    };

    const signInWithGoogle = async () => {
        // const { error } = await supabase_service_role.auth.signInWithOAuth({ provider: "google" });
        const error = null
        if (error) alert(error.message);
    };

    return (
        <div className="p-16">
            <div className="auth-container">
                <img src="hyk_logo.png" width={106} height={106} />
                <p className="fs-md2 fw-bold mb-40 mt-0">Welcome to HYK XX</p>
                {/* <p className="fg-black mt-0 mb-40">You have been invited by <span className="fg-red fw-bold">Ismail Chaib</span></p> */}
                {errorMessage && <p className="error-message">{errorMessage}</p>}
                <form onSubmit={handleSignUp} className="auth-form">
                    {/* <input className="input-field" placeholder="Email address" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /> */}
                    {/* <Input
                        type="email"
                        initialValue={email}
                        onChange={(v) => setEmail(v)}
                        placeholder="Email address"
                        classNames="mb-16 input-main"
                    /> */}
                    <input 
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email address"
                        className="mb-16 input-main"
                        required
                    />
                    <button type="submit" className="btn red-btn btn-full" disabled={loading}>{loading ? "Redirecting ..." : "Sign Up with email"}</button>
                    {/* <Separator text="OR" /> */}
                    <p className="fs-xxs fg-crea fw-medium ta-center mt-8 mb-0">OR CONTINUE WITH</p>
                </form>
                <div className="social-group">
                    {/* <button onClick={signInWithGoogle} className="btn red-outline-btn btn-full-v fs-xs mt-24">
                        <img src="google.png" className={"icon"} width={18} height={18} alt="google" />
                        Google
                    </button> */}
                    <p className="fg-crea ta-center fs-xxs fw-medium mt-24">ALREADY HAVE AN ACCOUNT? <span onClick={() => navigate("/login")} className="fg-red-pink fw-bold c-pointer">LOGIN</span></p>
                </div>
            </div>
        </div>
    );
}
